import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useRequestData, useLabels } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { setClassNames } from 'ddc-classnames-js';
import ClearFilters from '../components/ClearFilters';
import FilterItem from '../components/FilterItem';
import FilterItemList from '../components/FilterItemList';
import InventorySort from './InventorySort';
import VehicleCount from './VehicleCount';

const FilterModalButton = ({ sortOptions, count, appliedFilters }) => {
	const [showModal, setModalShow] = useState(false);
	const [animationName, setAnimationName] = useState(null);
	const { widgetName, windowId } = useRequestData();
	const labels = useLabels();
	const buttonLabel = labels.get('FILTER_SLASH_SORT');
	// define feature flag for scroll to top listing on filter

	const hideModal = () => {
		// Remove animation className and allow animation transition before removing modal
		setAnimationName(null);
		setTimeout(() => {
			setModalShow(false);
			// scroll to top of listings on mobile facets after submitting
			window.DDC.scrollToAnchor(
				$('[data-widget-id="inventory-filters1"]'),
				{
					heightAdj: $('.header-minimal-container').height()
				}
			);
		}, 300);
	};

	useEffect(() => {
		if (showModal) {
			window.DDC.InvData.publishEvent('ws-inv-filters/modal-show');

			// Add animation className after modal element is found
			const updateModal = () => {
				const modal = document.querySelectorAll('.modal.dock-full');
				if (modal) {
					setTimeout(() => setAnimationName('slide'), 50);
					// eslint-disable-next-line no-use-before-define
					clearInterval(intervalModal);
				}
			};
			const intervalModal = setInterval(updateModal, 50);

			trackEvent(widgetName, windowId, {
				element: 'Filter/sort button',
				elementCTA: 'Filter/Sort',
				result: 'Filter panel displayed'
			});
		} else {
			window.DDC.InvData.publishEvent('ws-inv-filters/modal-hide');
		}
	}, [showModal, widgetName, windowId]);

	return (
		<React.Fragment>
			<Modal
				show={showModal}
				animation={false}
				onHide={hideModal}
				className={setClassNames(['dock-full', animationName])}
			>
				<Modal.Body>
					<div className="d-flex mb-3">
						<Modal.Title className="ddc-font-size-large">
							{buttonLabel}
						</Modal.Title>
						<button
							id="hide-filters-modal-button"
							className="text-link font-weight-bold ml-auto"
							onClick={hideModal}
						>
							{labels.get('DONE')}
						</button>
					</div>
					{!!appliedFilters.length && (
						<React.Fragment>
							<FilterItemList minBreakpoint="xs">
								{appliedFilters.map(filter =>
									filter.values.map(item => (
										<FilterItem
											{...item}
											key={[filter.id, item.value].join(
												'-'
											)}
											filterId={filter.id}
											filterLabel={filter.label}
										/>
									))
								)}
								<ClearFilters
									label={labels.get('CLEAR_FILTERS')}
								/>
							</FilterItemList>
							<hr className="modal-divider" />
						</React.Fragment>
					)}
					<InventorySort {...{ sortOptions }} />
					<hr className="modal-divider mb-0" />
					<div className="modal-filters-react-portal" />
				</Modal.Body>
				<Modal.Footer className="top-gradient border-0">
					<VehicleCount
						count={count}
						displayStyle="modalButton"
						setModalShow={setModalShow}
						hasFilters={!!appliedFilters.length}
					/>
				</Modal.Footer>
			</Modal>

			<button
				id="show-filters-modal-button"
				className="text-link ddc-font-size-large font-weight-bold pl-4 flex-shrink-0 d-lg-none"
				onClick={() => setModalShow(true)}
			>
				{buttonLabel}
			</button>
		</React.Fragment>
	);
};

FilterModalButton.propTypes = {
	count: PropTypes.number.isRequired,
	sortOptions: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			label: PropTypes.string
		})
	),
	appliedFilters: PropTypes.arrayOf(PropTypes.object)
};

FilterModalButton.defaultProps = {
	sortOptions: [],
	appliedFilters: []
};

export default FilterModalButton;
